import React from 'react';
import { IconButton, TableCell, TableRow } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import useTranslate from '../../../../customHooks/useTranslate';
import TextInput from '../../../../muiComponents/TextInput/TextInputV2';
import { ChildrenAgeSegmentState } from '../../../../types/properties/propertyTypes';

interface AgeRangeRowProps {
    segment: ChildrenAgeSegmentState;
    fromAge: number;
    adultAge: number;
    nextAge: number;
    canDelete: boolean;
    onUpdateAge: (key: string, age: number) => void;
    onDeleteRange: (key: string) => void;
    onAgeBlur: () => void;
    disabled: boolean;
}

const AgeRangeRow = ({
    segment,
    fromAge,
    adultAge,
    nextAge,
    canDelete,
    onUpdateAge,
    onDeleteRange,
    onAgeBlur,
    disabled,
}: AgeRangeRowProps) => {
    const translate = useTranslate();
    const minimumAge = fromAge + 1;
    const maximumAge = Math.min(adultAge, nextAge - 1);

    const handleAgeChange = (
        _event: React.ChangeEvent<HTMLInputElement>,
        value: string
    ) => {
        onUpdateAge(segment.key, value ? Number(value) : 0);
    };

    return (
        <TableRow id={`age-range-${segment.key}`}>
            <TableCell>{segment.name}</TableCell>
            <TableCell>
                <div className='flex flex-center'>{fromAge}</div>
            </TableCell>
            <TableCell>
                <TextInput
                    disabled={disabled}
                    deleteIcon={false}
                    handleChange={handleAgeChange}
                    inputProps={{
                        max: maximumAge,
                        min: minimumAge,
                        step: 1,
                    }}
                    onBlur={onAgeBlur}
                    size='small'
                    type='number'
                    value={segment.age}
                    variant='outlined'
                />
            </TableCell>
            <TableCell>
                <div className='flex flex-center'>
                    <IconButton
                        aria-label={`${translate('delete')}: ${segment.name}`}
                        disabled={disabled || !canDelete}
                        onClick={() => onDeleteRange(segment.key)}
                        size='small'
                    >
                        <DeleteOutlineIcon fontSize='small' />
                    </IconButton>
                </div>
            </TableCell>
        </TableRow>
    );
};

export default AgeRangeRow;
